import { DownloadSimple } from "@phosphor-icons/react";
import { Button, Text, Spinner } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import Common from "api/common/common";
import { showErrorToast } from "utils";
import { useState } from "react";

/**
 * A button to download a FileInfo.
 *
 * @param {React.ReactNode} as - The component to render the button as. Use Text for text-not-button display.
 * @param {FileInfo} fileInfo - The file info to download.
 * @param {React.ReactNode} children - If unset, a download icon is used
 */
export default function FileDownloadButton({
  as,
  fileInfo,
  children,
  cursor="pointer",
  variant="outline",
  width="100%",
  ...props
}) {
  const toast = useToast();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = () => {
    setIsDownloading(true);
    Common.getAttachment({ attachmentId: fileInfo.documentId })
      .then(() =>
        toast({
          title: "File downloaded",
          description: (fileInfo.title || fileInfo.filename) + " has been downloaded to your computer.",
          status: "success",
        })
      )
      .catch((err) => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message))
      .finally(() => setIsDownloading(false));
  };

  const B = as === Text ? Text : Button;

  return (
    <B
      width={width}
      as={as}
      variant={variant}
      onClick={handleDownload}
      title={"Download " + fileInfo.filename}
      padding={0} /* otherwise the icon goes tiny */
      {...props}
    >
      {children || <DownloadSimple size={16} />} {isDownloading && <Spinner size="xs" />}
    </B>
  );
}
